import { getFavoritePages as fetchFavoritePages, createFavoritePage, deleteFavoritePage } from "@/api/core"
import { FavoritePage, MenuGroupValue } from "@/models/menus/menu"
import { defineStore } from "pinia"
import { ref } from "vue"

export const useMenuStore = defineStore("menu", () => {
    const isMenuExpanded = ref(true)
    const toggleMenuExpansion = () => {
        isMenuExpanded.value = !isMenuExpanded.value
        if (isMenuExpanded.value) {
            activateRailMode()
        } else {
            deactivateRailMode()
        }
    }

    const openMenus = ref<MenuGroupValue[]>([])
    const openMenusBackup = ref<MenuGroupValue[]>([])
    const openFavoriteMenus = ref<string[]>([])
    const openFavoriteMenusBackup = ref<string[]>([])

    const deactivateRailMode = () => {
        openMenusBackup.value = [...openMenus.value]
        openMenus.value = []
        openFavoriteMenusBackup.value = [...openFavoriteMenus.value]
        openFavoriteMenus.value = []
    }

    const activateRailMode = () => {
        openMenus.value = [...openMenusBackup.value]
        openFavoriteMenus.value = [...openFavoriteMenusBackup.value]
    }

    const favorites = ref<FavoritePage[]>([])
    const getFavoritePages = async (): Promise<void> => {
        try {
            const fetchedFavorites: FavoritePage[] = await fetchFavoritePages()
            // TODO: To remove
            favorites.value = fetchedFavorites.filter(
                favorite =>
                    favorite.title !== "Tickets" &&
                    favorite.title !== "Audrey prefilled answers" &&
                    favorite.path !== `${import.meta.env.VITE_API_BACKEND_URL}/admin/saas_parameters`
            )
        } catch (err) {
            favorites.value = []
            throw err
        }
    }
    const addFavorite = async (payload: Omit<FavoritePage, "id">): Promise<FavoritePage> => {
        const createdFavorite: FavoritePage = await createFavoritePage(payload)
        favorites.value.push(createdFavorite)
        return createdFavorite
    }
    const deleteFavorite = async (id: number): Promise<void> => {
        await deleteFavoritePage(id)
        favorites.value = favorites.value.filter(fav => fav.id !== id)
    }

    return {
        openMenus,
        openFavoriteMenus,
        isMenuExpanded,
        toggleMenuExpansion,
        deactivateRailMode,
        activateRailMode,
        favorites,
        getFavoritePages,
        addFavorite,
        deleteFavorite
    }
})
